import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "68699d88-d542-4c36-8ea2-8e1e61d8e07c",
  title: "Hal Higdon: Intermediate 1",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "9 miles",
      totalDistance: 9,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "6 miles",
      totalDistance: 6,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "11 miles",
      totalDistance: 11,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "9 miles",
      totalDistance: 9,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles pace",
      totalDistance: 7,
    },
    {
      description: "14 miles",
      totalDistance: 14,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "15 miles",
      totalDistance: 15,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "13.1 miles Half Marathon",
      totalDistance: 13.1,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles pace",
      totalDistance: 8,
    },
    {
      description: "17 miles",
      totalDistance: 17,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "18 miles",
      totalDistance: 18,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles pace",
      totalDistance: 8,
    },
    {
      description: "13 miles",
      totalDistance: 13,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles pace",
      totalDistance: 4,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "2 miles run",
      totalDistance: 2,
    },
    { description: "Marathon", totalDistance: 26.2 },
  ],
} as BuiltInPlan;